import { useContext } from 'react';
import type { Editor } from '@tiptap/core';

import ToolbarButton from '@modules/documents/components/header/toolbar/ToolbarButton';
import DocumentContext from '../../../contexts/DocumentContext.context';

import { UploadButton } from '@shared/components';
import { checkImageSizeLimit } from '../../utils/imageInsert';
import { TEMPLATE_FIELD_INLINE_NAME } from '../../../doc-engine/templateFields';

const ImageNodeButton = () => {
  const { editor } = useContext(DocumentContext);

  return (
    <UploadButton
      Button={ToolbarButton}
      accept="image/*"
      handleFiles={async (files) => {
        if (checkImageSizeLimit(files[0])) editor.chain().focus().insertImage(files[0]).run();
      }}
      icon={
        <svg height="100%" width="100%" viewBox="0,0,2048,2048" focusable="false">
          <path
            type="path"
            style={{ fill: 'transparent' }}
            d="M 1485 794 q -27 0 -50 -10 q -23 -10 -40 -28 q -18 -17 -28 -41 q -10 -23 -10 -49 q 0 -27 10 -50 q 10 -23 28 -41 q 17 -17 40 -27 q 23 -10 50 -10 q 26 0 50 10 q 23 10 41 27 q 17 18 27 41 q 10 23 10 50 q 0 26 -10 49 q -10 24 -27 41 q -18 18 -41 28 q -24 10 -50 10 m -1383 -487 h 1844 v 1434 h -1844 m 1741 -1331 h -1638 v 746 l 461 -460 l 563 563 l 256 -256 l 358 358 m -1638 -60 v 337 h 1259 l -798 -798 m 942 798 h 235 v -132 l -358 -358 l -184 183 z"
          ></path>
          <path type="path" style={{ fill: '#FAFAFAFF' }} d="M 1894 1690 h -1740 v -1332 h 1740 z"></path>
          <path
            type="path"
            style={{ fill: '#83BEECFF' }}
            d="M 152 1278 l 514 -504 l 569 549 l 250 -246 l 413 401 v 211 h -1746 z"
          ></path>
          <path
            type="path"
            style={{ fill: '#0063B1FF' }}
            d="M 1858 1521 l -373 -373 l -184 183 l 322 322 l -72 73 l -885 -886 l -476 476 l -73 -72 l 549 -548 l 563 563 l 256 -256 l 446 446 z"
          ></path>
          <path
            type="path"
            style={{ fill: '#DE6C00FF' }}
            d="M 1485 794 q -27 0 -50 -10 q -23 -10 -40 -28 q -18 -17 -28 -41 q -10 -23 -10 -49 q 0 -27 10 -50 q 10 -23 28 -41 q 17 -17 40 -27 q 23 -10 50 -10 q 26 0 50 10 q 23 10 41 27 q 17 18 27 41 q 10 23 10 50 q 0 26 -10 49 q -10 24 -27 41 q -18 18 -41 28 q -24 10 -50 10 z"
          ></path>
          <path
            type="path"
            style={{ fill: '#FFFFFF00' }}
            d="M 1459 653 q 0 44 17 83 q 16 39 45 68 q 29 30 68 47 q 38 18 82 19 q -27 24 -61 38 q -35 14 -74 14 q -42 0 -79 -16 q -38 -16 -66 -44 q -28 -28 -44 -66 q -16 -37 -16 -79 q 0 -39 14 -74 q 14 -34 38 -61 q 24 -27 57 -45 q 32 -17 70 -22 q -23 28 -37 63 q -14 35 -14 75 z"
          ></path>
          <path
            type="path"
            style={{ fill: '#3A3A38FF' }}
            d="M 102 307 h 1844 v 1434 h -1844 m 1741 -103 v -1228 h -1638 v 1228 z"
          ></path>
        </svg>
      }
      tooltip="Insert Picture"
      // Inline fields hold inline content only.
      disabled={(e: Editor) => e.isActive(TEMPLATE_FIELD_INLINE_NAME)}
    >
      Picture
    </UploadButton>
  );
};

export default ImageNodeButton;
